import { useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { fetchTerms, fetchPrivacyPolicy } from '../processes/wordpress';

const MODAL_CONFIG = {
	terms: {
		title: 'Termos e Condições de Uso',
		fetchFn: fetchTerms,
		errorMessage: 'Não foi possível carregar os termos, tente novamente mais tarde.'
	},
	privacy: {
		title: 'Política de Privacidade e Proteção de Dados Pessoais',
		fetchFn: fetchPrivacyPolicy,
		errorMessage: 'Não foi possível carregar a política de privacidade, tente novamente mais tarde.'
	}
};

function useTermsModal() {
	const [isOpen, setIsOpen] = useState(false);
	const [loading, setLoading] = useState(false);
	const [content, setContent] = useState('');
	const [modalType, setModalType] = useState(null);

	const title = modalType ? MODAL_CONFIG[modalType].title : '';

	const openModal = useCallback(async (type) => {
		const config = MODAL_CONFIG[type];
		setIsOpen(true);
		setLoading(true);
		setModalType(type);

		const { data, error } = await config.fetchFn();

		if (error || !data) {
			setIsOpen(false);
			setLoading(false);
			toast.error(config.errorMessage);
			return;
		}

		setContent(data.content || '');
		setLoading(false);
	}, []);

	const openTerms = useCallback(() => openModal('terms'), [openModal]);
	const openPrivacy = useCallback(() => openModal('privacy'), [openModal]);

	const closeModal = useCallback(() => {
		setIsOpen(false);
		setContent('');
	}, []);

	return {
		isOpen,
		loading,
		content,
		title,
		closeModal,
		openTerms,
		openPrivacy
	};
}

export default useTermsModal;
